"use client";

import React from "react";
import { Search, ShieldCheck, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Claridad",
  description: "Identificamos juntos tus metas reales y los obstáculos que te impiden avanzar hacia tu mejor versión en una sesión inicial profunda.",
  icon: Search
}, {
  title: "Estrategia",
  description: "Diseñamos un camino personalizado con herramientas de coaching adaptadas a tu ritmo, necesidades específicas y valores fundamentales.",
  icon: ShieldCheck
}, {
  title: "Evolución",
  description: "Implementamos cambios sostenibles que transforman tu mentalidad y te permiten alcanzar resultados extraordinarios de forma autónoma.",
  icon: Users
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="5191" id="cómo-funciona-el-proceso" ref={ref} className="bg-muted-light-background py-[120px] relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="space-y-12 relative">
          {steps.map((step, index) => {
          const isLast = index === steps.length - 1;
          return <div key={index} data-index={index} className={cn("flex gap-6 md:gap-10 transition-all duration-700 ease-out group hover:-translate-y-[2px]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
            transitionDelay: `${index * 200}ms`
          }}>
                {/* Timeline Line & Icon */}
                <div className="flex flex-col items-center relative shrink-0">
                  {/* Icon Circle */}
                  <div className="z-10 flex items-center justify-center w-12 h-12 rounded-full bg-accent text-foreground-accent shadow-soft ring-4 ring-muted-light-background transition-colors duration-medium group-hover:bg-accent-hover">
                    <step.icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  
                  {/* Connector Line */}
                  {!isLast && <div className="absolute top-12 bottom-[-48px] w-0.5 bg-accent/20" />}
                </div>

                {/* Content */}
                <div className="pb-4 pt-1">
                  <h3 className="text-2xl font-display font-semibold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-lg leading-relaxed font-sans">
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}